import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { IRequestPermission } from "@schema/permissions";
import { PermissionService } from "@core/service/permission.service";

@Directive({
  selector: "[appShowIfUserCannot]"
})
export class ShowIfUserCannotDirective {

  /**
   * If the current template is already shown
   */
  protected hasView = false;

  constructor(
    protected _templateRef: TemplateRef<any>,
    protected _viewContainer: ViewContainerRef,
    protected _permissionService: PermissionService,
  ) { }

  @Input("appShowIfUserCannot") set appShowIfUserCan(request: IRequestPermission) {
    const userCannot = this._permissionService.cannot(request.permission, request.global);

    if (userCannot && !this.hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this.hasView = true;
    } else if (!userCannot && this.hasView) {
      this._viewContainer.clear();
      this.hasView = false;
    }
  }

}
